/** Public project tokens are identifiers embedded in browser bundles, not secrets. */
export const SITE_POSTHOG_PROJECT_TOKEN =
  "phc_mGfayMe6o8oeCf2CSoyanVx7p84A89yr4sBUHUTyJHBD";

export const SITE_POSTHOG_API_HOST = "https://us.i.posthog.com";

export const APP_STORE_URL =
  "https://apps.apple.com/au/app/sehaj-daily-sikh-stories/id6787699607";

export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=app.sehaj.mobile";

/**
 * Canonical website-to-funnel destination.
 *
 * Keep Polar selection and website attribution together so every public-site
 * CTA reaches the intended checkout and remains segmentable in PostHog without
 * overwriting the campaign that originally brought someone to the site.
 */
export const START_JOURNEY_URL =
  "https://start.sehaj.app/?checkout=polar&source=website";

/**
 * Keep the primary journey in the same tab so the hand-off feels continuous.
 * Store and other external destinations may open separately.
 */
export const shouldOpenSiteLinkInNewTab = (key: string, url: string): boolean =>
  key !== "funnel" && /^https?:/.test(url);
